import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  List,
  ListItem,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { MailInfo } from '../../../models/interfaces';
import CustomizedDialog from '../CustomizedDialog';
import SelectMenu from '../SelectMenu';
import {
  SHARE_PERM_DROPDOWN,
  SHARE_PERM_DROPDOWN_TEXT,
  STATUS_CODE,
} from '../../../utils/constants';
import {
  getSharedUsers,
  getSuggestionUsers,
  putSharedUsers,
  deleteSharedUsers,
  changeRoleSharedUsers,
} from '../../../services/share-drive-service';
import Loading from '../Loading';
import ShareIcon from '@mui/icons-material/Share';

interface IProps {
  onClose: () => void;
  open: boolean;
  selectedId: string;
  title?: string;
}

export default function ShareModal(props: IProps) {
  const { onClose, open, selectedId, title } = props;
  const [selectedMails, setSelectedMails] = useState<MailInfo[]>([]);
  const [listMail, setListMail] = useState<MailInfo[]>([]);
  const [currentMails, setCurrentMails] = useState<MailInfo[]>([]);
  const menuItems = (data: MailInfo) => [
    {
      text: SHARE_PERM_DROPDOWN_TEXT.VIEWER,
      callback: () => changePerm(data, SHARE_PERM_DROPDOWN.VIEWER),
    },
    {
      text: SHARE_PERM_DROPDOWN_TEXT.EDITOR,
      callback: () => changePerm(data, SHARE_PERM_DROPDOWN.EDITOR),
    },
    {
      text: SHARE_PERM_DROPDOWN_TEXT.REMOVE,
      callback: () => changePerm(data, SHARE_PERM_DROPDOWN.REMOVE),
    },
  ];
  const [sharedLoading, setSharedLoading] = useState(false);
  const [role, setRole] = useState(SHARE_PERM_DROPDOWN.EDITOR);

  const changePerm = (data: MailInfo, perm: SHARE_PERM_DROPDOWN) => {
    let newSelectedMails = [...currentMails];
    if (perm === SHARE_PERM_DROPDOWN.REMOVE) {
      handleDeleteShareMails(data);
      newSelectedMails = currentMails.filter((item) => item.id !== data.id);
    } else {
      handleChangeRoleShareMails(data, perm);
      const index = currentMails.findIndex((item) => item.id === data.id);
      newSelectedMails[index].role = perm;
    }
    setCurrentMails(newSelectedMails);
  };

  const handleShareMails = async () => {
    try {
      setSharedLoading(true);
      let newSelectedMails = selectedMails
        .filter(
          (item) =>
            currentMails.filter((mail) => mail.id === item.id).length === 0
        )
        .map((item) => ({ ...item, role }));

      if (selectedMails.length > 0) {
        const res = await putSharedUsers(selectedMails, selectedId, role);
        if (res.status === STATUS_CODE.CREATED) {
          currentMails.forEach((item) => {
            const index = selectedMails.findIndex(
              (mail) => mail.id === item.id
            );
            if (index !== -1) {
              item.role = role;
            }
          });
          setSharedLoading(false);
          setCurrentMails([...currentMails, ...newSelectedMails]);
          setSelectedMails([]);
          // onClose();
        } else {
          setSharedLoading(false);
          setSelectedMails([]);
        }
      } else {
        setSelectedMails([]);
        setSharedLoading(false);
        // onClose();
      }
    } catch (error) {
      setSelectedMails([]);
      setSharedLoading(false);
      // todo handle error
    }
  };

  const handleGetSuggestionMails = async () => {
    try {
      const res = await getSuggestionUsers();
      if (res.status === STATUS_CODE.SUCCESS) {
        setListMail(res.data || []);
      } else {
        // todo
      }
    } catch (error) {
      // todo handle error
    }
  };

  const handleDeleteShareMails = async (mail: MailInfo) => {
    try {
      const res = await deleteSharedUsers(selectedId, mail.id);
      if (res.status === STATUS_CODE.SUCCESS) {
        // todo
      } else {
        // todo
      }
    } catch (error) {
      // todo handle error
    }
  };

  const handleChangeRoleShareMails = async (
    mail: MailInfo,
    perm: SHARE_PERM_DROPDOWN
  ) => {
    try {
      const res = await changeRoleSharedUsers(selectedId, mail.id, perm);
      if (res.status === STATUS_CODE.SUCCESS) {
        // todo
      } else {
        // todo
      }
    } catch (error) {
      // todo handle error
    }
  };

  useEffect(() => {
    if (selectedId) {
      const handleGetShareMail = async () => {
        try {
          setSharedLoading(true);
          const res = await getSharedUsers(selectedId);
          if (res.status === STATUS_CODE.SUCCESS) {
            setCurrentMails(res.data || []);
            setSharedLoading(false);
          } else {
            // todo
          }
        } catch (error) {
          // todo handle error
        }
      };
      handleGetShareMail();
    }
  }, [selectedId]);

  useEffect(() => {
    handleGetSuggestionMails();
  }, []);

  return (
    <CustomizedDialog
      open={open}
      title={
        <div>
          シェア {title || ''} <ShareIcon />
        </div>
      }
      size={'xs'}
      content={
        <>
          <Box sx={{ padding: '1rem', display: 'flex', gap: '16px' }}>
            <Autocomplete
              multiple
              disableClearable
              id="autoComplete"
              className="auto-complete"
              options={listMail}
              getOptionLabel={(option) => option.email}
              value={selectedMails}
              isOptionEqualToValue={(option, value) =>
                option.email === value.email
              }
              onChange={(_, newValue: MailInfo[]) => {
                setSelectedMails(newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} fullWidth className="input-select" />
              )}
            />
            {selectedMails.length > 0 && (
              <Select
                displayEmpty
                id="role-select"
                value={role}
                sx={{ height: 56 }}
                onChange={(e) => setRole(e.target.value as SHARE_PERM_DROPDOWN)}
              >
                <MenuItem value={SHARE_PERM_DROPDOWN.VIEWER}>
                  {SHARE_PERM_DROPDOWN_TEXT.VIEWER}
                </MenuItem>
                <MenuItem value={SHARE_PERM_DROPDOWN.EDITOR}>
                  {SHARE_PERM_DROPDOWN_TEXT.EDITOR}
                </MenuItem>
              </Select>
            )}
          </Box>
          <List disablePadding>
            {currentMails.map((item) => (
              <ListItem
                key={item.id}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div>{item.email}</div>
                <div>
                  {item?.is_owner ? (
                    <Button disabled>{SHARE_PERM_DROPDOWN_TEXT.OWNER}</Button>
                  ) : (
                    <SelectMenu
                      menuItems={menuItems(item)}
                      idButton="btnSelectPerm"
                      idMenu="permOptionMenu"
                      textButton={
                        item.role
                          ? (SHARE_PERM_DROPDOWN_TEXT as any)[item.role]
                          : ''
                      }
                      endIcon={<KeyboardArrowDownIcon />}
                      className="select-btn"
                    />
                  )}
                </div>
              </ListItem>
            ))}
            {sharedLoading && (
              <Box sx={{ position: 'relative' }}>
                <Loading isLoad={sharedLoading} />
              </Box>
            )}
          </List>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              padding: '1rem',
            }}
          >
            <Button
              variant="contained"
              color="inherit"
              disableElevation
              sx={{ width: '120px' }}
              onClick={handleShareMails}
              disabled={sharedLoading || selectedMails.length === 0}
            >
              シェアする
            </Button>
          </Box>
        </>
      }
      onClose={onClose}
    />
  );
}
